import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import {
  ActionButton,
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import InsuranceIllustration from "../../assets/client/uv/insurance.svg?react";
import "./styles.scss";
import { INSURANCE_POLICY_LINK } from "../MobileHamburgerMenu/constants";

export const InsuranceBlurbModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useI18nContext();

  const handleIssuePolicy = () => {
    window.open(INSURANCE_POLICY_LINK, "_blank");
  };

  return (
    <MobilePopoverCard
      open={open}
      onClose={onClose}
      fullScreen={true}
      className="insurance-blurb-modal"
      contentClassName="insurance-blurb-modal-content"
      topRightButton={
        <ActionLink
          className="close-button"
          content={
            <IconComponent
              ariaLabel={t("modalClose.ariaLabel")}
              className="close-button-icon"
              name={IconName.Close}
            />
          }
          label={t("modalClose.label")}
          onClick={onClose}
        />
      }
      bottomButton={
        <ActionButton
          className="issue-policy-button-wrapper primary-button-wrapper"
          buttonClassName="issue-policy-button primary-button"
          message={t("insuranceModal.issuePolicy")}
          onClick={handleIssuePolicy}
        />
      }
    >
      <div className="modal-body">
        <div className="illustration-container">
          <InsuranceIllustration className="illustration" />
        </div>
        <h1 className="modal-title">{t("insuranceModal.title")}</h1>
        <p className="modal-description">
          <Trans
            i18nKey="insuranceModal.description"
            components={{
              bold: <span style={{ fontWeight: 500 }} />,
            }}
          />
        </p>
        <div className="mastercard-callout">
          <p>
            <Trans
              i18nKey="insuranceModal.mastercardCallout"
              components={{
                bold: <span style={{ fontWeight: 500 }} />,
              }}
            />
          </p>
        </div>
      </div>
    </MobilePopoverCard>
  );
};
